@if (required) {
  <div class="weaveFormField"
    [ngClass]="{'error': name.invalid && (name.dirty || name.touched)}"
    >
    @if (label) {
      <label [htmlFor]="id" class="darkLabel">{{label}}</label>
    }
    <input type="password" class='weaveInput'
      [disabled]="disabledFlag"
      (keyup.enter)="onFocusOut()"
      (focusout)="onFocusOut()"
      (keyup)="onKeyUp()"
      (keydown.enter)='$event.target.blur()'
      [(ngModel)]='data'
      (focusin)="startEdit()"
      (keydown.escape)="undo()"
      [placeholder]="placeholder"
      [id]="id"
      required
      #name="ngModel"
      >
      @if (name.invalid && (name.dirty || name.touched)) {
        <div
          class="weaveFormField_error">
          {{label}} cannot be empty
        </div>
      }
    </div>
  }
  @if (!required) {
    <div class="weaveFormField"
      >
      @if (label) {
        <label [htmlFor]="id" class="darkLabel">{{label}}</label>
      }
      <input type="password" class='weaveInput'
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [id]="id"
        >
      </div>
    }
